package com.milta.feature.profile.domain.usecase

import com.milta.feature.profile.domain.entity.ProfileEntity
import com.milta.feature.profile.domain.repository.ProfileRepository

class GetProfileUseCase(private val repository: ProfileRepository) {
    suspend operator fun invoke(): Result<ProfileEntity> = repository.getProfile()
}
